import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Language extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): Language {
    return new Language(value);
  }
}
